import { useState } from 'react'
import { REGISTRATION_OTP_VERIFY } from '../../Utils/apis';
import useUserSetup from '../useUserSetup';


const useRegistOtpVerify = (onSucess) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isSucess, setIsSucess] = useState(false);
    const userSetUp = useUserSetup();

    const fn = async (info) => {

        // info object should be contain { email, otp, password}, all details are mandatory

        if (!loading) {
            try {
                setLoading(true)
                const res = await fetch(REGISTRATION_OTP_VERIFY,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(info),
                        credentials: 'include',
                    }
                );

                if (res.ok) {
                    const user = await res.json();
                    // sessionStorage.setItem("token", user.token)
                    userSetUp(user?.data?.token);    
                    // console.log("token and user value", user?.data?.token);                
                    onSucess();
                }
                else {
                    const err = await res.json();
                    setError(err.message);
                }
            } catch (error) {
                setError(error.message);
                // return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }

            // return Promise.resolve('');
            return info;
        }
    }

    return [loading, error, isSucess, fn];
}

export default useRegistOtpVerify;